import { useNavigate, useParams } from "react-router-dom";
import callAPI from "../../../../../../api/apiCaller.js";
import Icon from "../../../../../../common/Icon";
import {
  CloseButton,
  ModalContainer,
  ModalCloseHeader,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
  ModalFooter,
  ProfileInfo,
  ApplicationModalButton,
  ApplicationModalDate,
  ApplicationModalHeader,
  ApplicationModalLabel,
  ApplicationModalOption,
  ApplicationModalOptionGroup,
  ApplicationModalProfile,
  ApplicationModalProfileInfo,
  ApplicationModalProfileThumb,
  ApplicationModalProfileTitle,
  ApplicationModalSection,
  ApplicationModalOuter,
} from "./styles.js";
import React from "react";
import { Context } from "../../../../../../Store/index.js";
import Loading from "../../../../../../common/Loading/index.js";
import { ModalLoaderContainer } from "./styles.js";
import { ApplicationModalFooterContainer } from "./styles.js";
import { Avatar } from "./styles.js";

const fallBackImageUrl =
  "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png";

const ApplicationModal = ({
  applicationModal = null,
  setApplicationModal,
  setIsOpenApplicationModal,
  recallAPIs,
}) => {
  const { dispatch } = React.useContext(Context);
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);
  const [apiLoader, setAPILoader] = React.useState(false);
  const [questions, setQuestions] = React.useState({});
  const [answers, setAnswers] = React.useState({});
  const thumb = applicationModal?.participant?.image
    ? applicationModal?.participant?.image
    : applicationModal?.image || fallBackImageUrl;
  const name = `${
    applicationModal?.firstName
      ? applicationModal?.firstName
      : applicationModal?.participant.firstName || ""
  } ${
    applicationModal?.lastName
      ? applicationModal?.lastName
      : applicationModal?.participant.lastName || ""
  }`;

  const userProgramStatus = applicationModal?.status;
  // ? applicationModal?.status
  // : applicationModal?.participant.applicationStatus;

  const status = applicationModal?.applicationStatus
    ? applicationModal?.applicationStatus
    : applicationModal?.participant.applicationStatus;
  const email = applicationModal?.email
    ? applicationModal?.email
    : applicationModal?.participant.email;
  const university = applicationModal?.university || ""; // Placeholder for university
  const roles = applicationModal?.role
    ? applicationModal?.role
    : applicationModal?.joinAs;
  const id = applicationModal?.id;
  const uuid = applicationModal?.uuid;

  const programInformation = () => {
    callAPI(dispatch, "getUserProgramApplication", {
      programId: params.selectedProgram,
      userId: applicationModal?.participant?.id
        ? applicationModal?.participant?.id
        : applicationModal?.id,
    })
      .then((data) => {
        const questions = {};
        const answers = {};
        data?.data?.forEach((d) => {
          questions[d?.questionId] = d.questions;
          answers[d?.questionId] = {
            ...(answers[d?.questionId] || {}),
            ...(d?.answer && { [d?.answer]: true }),
          };
        });
        setQuestions(questions);
        setAnswers(answers);
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    programInformation();
  }, []);

  function denyRequest(userId) {
    callAPI(dispatch, "denyRequest", {
      userId,
      programId: params.selectedProgram,
    }).then((res) => {
      if (res) {
        setIsOpenApplicationModal(null);
        setIsOpenApplicationModal(false);
        if (recallAPIs) {
          recallAPIs();
        }
      }
    });
  }

  function approveRequest(userId) {
    setAPILoader(true);
    callAPI(dispatch, "acceptRequest", {
      userId,
      programId: params.selectedProgram,
    })
      .then((res) => {
        if (res) {
          setIsOpenApplicationModal(null);
          setIsOpenApplicationModal(false);
          if (recallAPIs) {
            recallAPIs();
          }
        }
      })
      .finally(() => {
        setAPILoader(false);
      });
  }

  return (
    <ModalOverlay>
      <ModalContainer width="727px">
        {/* Modal Header */}
        <ModalHeader>
          <ModalTitle>Application</ModalTitle>
          <ModalCloseHeader>
            <CloseButton onClick={() => setApplicationModal(null)}>
              <Icon type="close" />
            </CloseButton>
          </ModalCloseHeader>
        </ModalHeader>

        {/* Loader */}
        {loading ? (
          <ModalLoaderContainer>
            <Loading />
          </ModalLoaderContainer>
        ) : (
          <>
            <ApplicationModalOuter>
              {/* Info */}
              <ApplicationModalHeader>
                <ApplicationModalProfile>
                  <ApplicationModalProfileInfo>
                    <ApplicationModalProfileThumb>
                      <Avatar
                        src={thumb}
                        alt={"loading.."}
                        width={50}
                        height={50}
                      />
                    </ApplicationModalProfileThumb>
                    <ApplicationModalProfileTitle>
                      <h3>{name}</h3>
                      <p>{roles}</p>
                    </ApplicationModalProfileTitle>
                  </ApplicationModalProfileInfo>

                  <ApplicationModalDate>
                    <div>
                      <small>Status</small>
                    </div>
                    <div>
                      <small style={{ textTransform: "capitalize" }}>
                        {status
                          ? status
                          : userProgramStatus
                          ? userProgramStatus
                          : ""}
                      </small>
                    </div>
                  </ApplicationModalDate>
                  <ProfileInfo>
                    <span>Email</span>
                    <a href={`mailto:${email}`}>{email}</a>
                  </ProfileInfo>
                  {university && (
                    <ProfileInfo>
                      <span>University Attended</span>
                      <span>{university}</span>
                    </ProfileInfo>
                  )}
                </ApplicationModalProfile>
              </ApplicationModalHeader>

              {/* Questions */}
              {(Object?.values(questions) || [])?.map((question) => (
                <ApplicationModalSection key={question?.id}>
                  <ApplicationModalLabel>
                    {question?.question}
                  </ApplicationModalLabel>

                  {/* Answers */}
                  {question?.multipleQuestion === null ? (
                    <>
                      {answers[question?.id] &&
                        Object?.keys(answers[question?.id])?.map((a) => (
                          <div key={a}>{a}</div>
                        ))}
                    </>
                  ) : (
                    <ApplicationModalOptionGroup>
                      {/* multiple questions */}
                      {question?.multipleQuestion?.options?.map(
                        (answer, index) => {
                          const answerObject = answers?.[question?.id] || {};
                          const answerKey = Object.keys(answerObject)[0];
                          let parsedAnswers = [];
                          if (
                            question?.multipleQuestion?.type === "Checkboxes" &&
                            answerKey &&
                            answerKey.startsWith("{")
                          ) {
                            parsedAnswers = answerKey
                              .replace(/^\{|\}$/g, "")
                              .split(",")
                              .map((item) => item?.trim().replace(/"/g, ""));
                          }
                          return (
                            <ApplicationModalOption key={index}>
                              <input
                                disabled={true}
                                type="checkbox"
                                checked={
                                  question?.multipleQuestion?.type ===
                                  "Checkboxes"
                                    ? parsedAnswers?.includes(answer)
                                    : answers?.[question?.id]?.[answer]
                                    ? true
                                    : false
                                }
                              />
                              {}
                              <span>{answer}</span>
                            </ApplicationModalOption>
                          );
                        }
                      )}
                    </ApplicationModalOptionGroup>
                  )}
                </ApplicationModalSection>
              ))}
            </ApplicationModalOuter>
          </>
        )}
        {/*Modal Footer */}

        <ModalFooter>
          <ApplicationModalFooterContainer>
            {status === "Pending" && (
              <>
                <ApplicationModalButton
                  variant="close"
                  onClick={(e) => denyRequest(id)}
                  // style={{margin:"0px", }}
                >
                  Decline
                </ApplicationModalButton>

                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  <ApplicationModalButton
                    variant="close"
                    onClick={() => {
                      callAPI(dispatch, "initializeConversation", {
                        id: id,
                      })
                        .then((res) => {
                          if (res) {
                            navigate(`/messages/${uuid}`);
                          }
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                    }}
                    // style={{margin:"0px"}}
                  >
                    Chat
                  </ApplicationModalButton>

                  <ApplicationModalButton
                    disabled={apiLoader}
                    variant="submit"
                    onClick={() => approveRequest(id)}
                    // style={{margin:"0px"}}
                  >
                    {apiLoader && (
                      <Icon type={"loading"} color="#FFFFFF"></Icon>
                    )}{" "}
                    Accept
                  </ApplicationModalButton>
                </div>
              </>
            )}
          </ApplicationModalFooterContainer>
        </ModalFooter>

        {/*Modal Footer */}
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ApplicationModal;
